import { FunctionalComponent, h, Fragment } from "preact";
import style from "./style.scss";
import commonStyle from "../../../components/common/style.scss";
import { useCallback, useContext, useState } from "preact/hooks";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { SectionTitle, Title, Required } from "../../../components/typography";
import Ribbon from "../../../components/ribbon";
import { TranslateContext } from "@denysvuika/preact-translate";
import Checkbox from "../../../components/checkbox";
import PaymentLogos from "../../../assets/images/payment_logos.png";

const FeedbackForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [task, setTask] = useState("");
  const [allowPersonalData, setAllowPersonalData] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const { t, lang } = useContext(TranslateContext);
  const validEmail = /.+@.+\..+/g.test(email);

  const send = useCallback(() => {
    fetch("https://clients-admin.wave909.com/feedback", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        task,
      }),
    })
      .then(() => {
        setIsSent(true);
      })
      .catch((error) => {
        console.log(error);
        setIsSent(false);
      });
  }, [name, email, task]);

  if (isSent) {
    return <div className={style.successbox}>{t("feedback.success")}</div>;
  }
  return (
    <Fragment>
      <SectionTitle>{t("feedback.name.title")}</SectionTitle>
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t("feedback.name.placeholder")}
      />
      <SectionTitle>
        {t("feedback.email.title")}
        <Required />
      </SectionTitle>
      <Input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("feedback.email.placeholder")}
      />
      <SectionTitle>{t("feedback.task.title")}</SectionTitle>
      <Input
        value={task}
        onChange={(e) => setTask(e.target.value)}
        placeholder={t("feedback.task.placeholder")}
      />
      <Checkbox
        id="personal"
        value={allowPersonalData}
        setValue={setAllowPersonalData}
      >
          {lang === 'ru' ? <Fragment>
              {t("feedback.allow_pers_data_1")}&nbsp;
              <a target="_blank" class="checkbox__label--link" href="/privacy">
                  {t("feedback.allow_pers_data_2")}
              </a>
              &nbsp;{t("feedback.allow_pers_data_3")}&nbsp;
              <a target="_blank" class="checkbox__label--link" href="/agreement">
                  {t("feedback.allow_pers_data_4")}
              </a>{" "}
          </Fragment> :
              <Fragment>
                  {t("feedback.allow_pers_data_1")}&nbsp;
                  <a target="_blank" class="checkbox__label--link" href="/privacy">
                      {t("feedback.allow_pers_data_2")}
                  </a>
                  &nbsp;{t("feedback.allow_pers_data_3")}
                  &nbsp;{t("feedback.allow_pers_data_4")}{" "}
          </Fragment>}

        <Required />


      </Checkbox>
      <Button
        className={style.button}
        onClick={allowPersonalData ? send : undefined}
        disabled={!allowPersonalData || !validEmail}
      >
        {t("feedback.send")}
      </Button>
      <div className={style.subtext}>{t("feedback.subtext")}</div>
    </Fragment>
  );
};

const Feedback = ({ style: _style = {} }) => {
  const { t, lang } = useContext(TranslateContext);
  return (
    <div style={_style} className={style["container"]}>
      <div className={[style["inner"], "width__full"].join(" ")}>
        <div className={[commonStyle["row-to-colr"], "width__full"].join(" ")}>
          <div
            className={[style["form"], "width__big", style.contacts].join(" ")}
          >
            <div
              className={[
                "text__size_title text__color_black",
                style.title,
                "width__full",
              ].join(" ")}
            >
              {t("feedback.contacts.title")}
            </div>
            <div className={"text__size_subtitle text__weight_300"}>
              e: <a href="mailto:hello@wave909.com">hello@wave909.com</a>
            </div>
            <div
              className={[
                "text__size_tag text__weight_300",
                style["contacts__description"],
              ].join(" ")}
            >
              {t("feedback.contacts.dm")}
              <a href="https://t.me/vadkou" target="_blank" rel="noreferrer">
                <TelegramIcon />
              </a>
            </div>
            <div>
              {/*<a>*/}
              {/*  <LinkedInIcon />*/}
              {/*</a>*/}
            </div>
            <p style='width: 80%;'>
              {t("feedback.explanation")
                .split("\n")
                .map((it) => (
                  <Fragment>
                    {it} <br />
                  </Fragment>
                ))}
              <a href="/payment-rules" target="_blank">
                  {t("feedback.rules")}
              </a>
              <br />
              <a href="/legal-info" target="_blank">
                  {t("feedback.requisites")}
              </a>
            </p>
            <p>
              <img
                src={PaymentLogos}
                alt="Логотипы платёжных систем"
                className={style["payment-img"]}
              />
            </p>
            <p>
                {t("feedback.since").replace('%CURRENT YEAR%', (new Date().getFullYear().toString()))}{" "}
                {lang === 'ru' && <sup>

                  <a
                      href="/assets/fl-318547600144272-20220206191014.pdf"
                      target="_blank"
                    >
                      (выписка из ЕГРИП)
                    </a>

              </sup>}
            </p>
          </div>
          <div className={[style["form"], "width__small"].join(" ")}>
            <FeedbackForm />
          </div>
        </div>
      </div>
      <Ribbon />
    </div>
  );
};

export default Feedback;
const TelegramIcon = () => (
  <svg
    className="t-sociallinks__svg"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 60 60"
  >
    <desc>Telegram</desc>
    <path
      style="fill:#000000;"
      d="M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm16.9 13.9l-6.7 31.5c-.1.6-.8.9-1.4.6l-10.3-6.9-5.5 5.2c-.5.4-1.2.2-1.4-.4L18 32.7l-9.5-3.9c-.7-.3-.7-1.5 0-1.8l37.1-14.1c.7-.2 1.4.3 1.3 1z"
    />
    <path style="fill:#000000;" d="M22.7 40.6l.6-5.8 16.8-16.3-20.2 13.3" />
  </svg>
);
const LinkedInIcon = () => (
  <svg
    className="t-sociallinks__svg"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="30px"
    height="30px"
    viewBox="0 0 48 48"
    enable-background="new 0 0 48 48"
  >
    <desc>LinkedIn</desc>
    <path
      style="fill:#000000;"
      d="M8.99402 37.97V38.47H9.49402H15.714H16.214V37.97V17.9659V17.4659H15.714H9.49402H8.99402V17.9659V37.97ZM26.077 19.2614V17.969V17.469H25.577H19.613H19.113V17.969V37.973V38.473H19.613H25.829H26.329V37.973V28.077C26.329 26.7816 26.4561 25.6098 26.9179 24.7713C27.1424 24.3639 27.4438 24.0395 27.8525 23.8131C28.2641 23.585 28.814 23.4399 29.558 23.4399C30.2745 23.4399 30.7691 23.6067 31.1207 23.8523C31.4735 24.0988 31.7253 24.4547 31.9038 24.906C32.2721 25.8373 32.29 27.0626 32.29 28.245V37.974V38.474H32.79H39H39.5V37.974V27C39.5 24.2955 39.2136 21.7867 38.0551 19.9487C36.8633 18.0579 34.8148 16.9709 31.546 16.9709C29.0885 16.9709 27.2261 18.003 26.077 19.2614ZM47.501 24C47.501 36.9798 36.9789 47.5 24.001 47.5C11.0211 47.5 0.499023 36.9798 0.499023 24C0.499023 11.0222 11.0211 0.5 24.001 0.5C36.9788 0.5 47.501 11.0261 47.501 24ZM12.604 15.74C14.8675 15.74 16.706 13.9008 16.706 11.634C16.706 9.36816 14.8674 7.52905 12.604 7.52905C10.3344 7.52905 8.5 9.36834 8.5 11.634C8.5 13.8952 10.3339 15.74 12.604 15.74Z"
    />
  </svg>
);
